import { render, staticRenderFns } from "./pi-balance-block.vue?vue&type=template&id=1fe0e982&scoped=true&"
import script from "./pi-balance-block.vue?vue&type=script&lang=js&"
export * from "./pi-balance-block.vue?vue&type=script&lang=js&"
import style0 from "./pi-balance-block.vue?vue&type=style&index=0&id=1fe0e982&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe0e982",
  null
  
)

export default component.exports